import { createFileRoute } from '@tanstack/react-router';

import { SupplierMessagesPage } from '@/features/messages/supplier-messages';

export const Route = createFileRoute('/_app/supplier/$orgId/messages/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { orgId } = Route.useParams();
  return <SupplierMessagesPage orgId={orgId} />;
}
